import React from 'react'
import { TopBanner, Wrapper } from './styled'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { FlexWrapper } from 'lib/ui/components'
import { Link } from 'react-router-dom'
import { Products } from './components/Products'

interface CmsBlockData {
  id: string
  updatedAt?: number
  content: string
  isSuccess: boolean
  isFailure: boolean
  isFirstLoad: boolean
}

export const Comparison = () => {
  const topBannerBlockID = CMS_BLOCK.COMPARISON_TOP_BANNER
  const topBannerBlock = useCmsBlock({
    id: topBannerBlockID,
    isLazy: false

  }) as CmsBlockData

  return (
    <Wrapper>
      <div>
        <TopBanner>
          {topBannerBlock.content && (
            <div
              dangerouslySetInnerHTML={{
                __html: topBannerBlock?.content ?? ''
              }}
            />
          )}
        </TopBanner>
        <h1>Compare products.</h1>
        <FlexWrapper className='flex'>
          <Link to='/'><strong> Back to Home</strong></Link>
        </FlexWrapper>
        <Products />
      </div>
    </Wrapper>
  )
}
